// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  name: __t.string(),
  discountPercent: __t.u32().name("discount_percent"),
  appliesTo: __t.string().name("applies_to"),
  startsAt: __t.u64().name("starts_at"),
  endsAt: __t.u64().name("ends_at"),
  isActive: __t.bool().name("is_active"),
  createdAt: __t.u64().name("created_at"),
});
